import FirstScreen from './first-screen';

export default FirstScreen;
